import React from 'react'
import Footer from '../components/footer.componets'
import Instagram from '../components/instagram.componets'
const Contact = () => {


    return (
        <>
            <section className="blog spad">
            <div className="container">
            <div className="row">
                <div className="col-lg-6 col-md-6">
                    <div className="contact__content">
                        <div className="contact__address">
                            <h5>Contact info</h5>
                            <ul>
                                <li>
                                    <h6><i className="fa fa-map-marker"></i> Address</h6>
                                    <p>Al Marina, Abu Dhabi - United Arab Emirates</p>
                                </li>
                                <li>
                                    <h6><i className="fa fa-phone"></i> Phone</h6>
                                    <p><span>125-711-811</span><span>125-668-886</span></p>
                                </li>
                                <li>
                                    <h6><i className="fa fa-headphones"></i> Support</h6>
                                    <p>Apnahai.shop@outlook.com</p>
                                </li>
                            </ul>
                        </div>
                        <div className="contact__form">
                            <h5>SEND MESSAGE</h5>
                         
                            <form action="#">
                                <input type="text" placeholder="Name"/>
                                <input type="text" placeholder="Email"/>
                                <input type="text" placeholder="Website"/>
                                <textarea placeholder="Message"></textarea>
                                <button type="submit" className="site-btn">Send Message</button>
                            </form>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6">
                    <div className="contact__map">
                        <iframe title='map'
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d10270.866829729104!2d54.31908333943297!3d24.4750674414066!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5e65b8333eef9b%3A0x59e45961004cc2ce!2sMarina%20Mall!5e0!3m2!1sen!2s!4v1655558118273!5m2!1sen!2s"
                        height="780" style={{ border: 0 }} allowfullscreen="">
                    </iframe>
                </div>
            </div>
        </div>
    </div>
    </section>
        
            <Instagram />
            <Footer/>
        </>
    )
}

export default Contact